export const URL = {
  /* ----------- 顾客端api ------------- */
  // 桌台信息取得
  TABLE_RETRIEVE: '/table/retrieve',
  // 桌台结账
  TABLE_CUSTOMER_CHECKOUT: '/table/customer/checkout',

  /* ----------- 管理端api ------------- */
  // 用户login
  LOGIN: '/admin/user/login',
  // 用户logout
  LOGOUT: '/admin/user/logout',
  // 菜品更新
  DISH_UPDATE: '/dish/update',
  // 菜品删除
  DISH_DELETE: '/dish/delete',
  // 菜品上下架更新
  DISH_DISPLAY_UPDATE: '/dish/display/update',
  // 桌台结束订单
  TABLE_FINISH: '/table/finish',
  // 全部桌台信息取得
  TABLE_ALL_TABLE_RETRIEVE: '/table/all-table/retrieve',
  // 结账
  ORDER_CHECKOUT: '/order/checkout',
  // 菜品退订
  ORDER_DISH_CANCEL: '/order/dish/cancel',
  // 上菜状态更新
  ORDER_SERVE_UPDATE: '/order/serve/update',
  // 未上菜的所有菜品取得
  ORDER_UNSERVED_RETRIEVE: '/order/unserved/retrieve',
  // 区间营业额取得
  STATISTICS_PERIOD_REVENUE_RETRIEVE: '/statistics/period-revenue/retrieve',
  // 日营业额取得
  STATISTICS_DAILY_REVENUE_RETRIEVE: '/statistics/daily-revenue/retrieve',
  // sse
  SSE_CONNECT: '/sse/connect',
  // 打印小票
  PRINT_RECEIPT: '/print/receipt‌',
  // 更换桌台
  TABLE_CHANGE: '/table/change',

  /* ----------- 共同api -------------- */
  // TENANT取得
  TENANT_RETRIEVE: '/tenant/retrieve',
  // 菜品取得
  DISH_RETRIEVE: '/dish/retrieve',
  // 分类取得
  CATEGORY_RETRIEVE: '/category/retrieve',
  // 订单信息取得
  ORDER_RETRIEVE: '/order/retrieve',
  // 下单
  ORDER_UPDATE: '/order/update',
  
}